
function Sucess() {
    return (<>
        <div className="w-full mx-auto flex items-center justify-center h-80">
            <img className="gif" src="https://images.squarespace-cdn.com/content/v1/6209fc508f791e729abec7d0/18641903-a848-4a3a-a0a3-c9e2ddaa15c4/02-lottie-tick-01-instant-2.gif" alt="" />
        </div>
    </>);
}

export default Sucess;